import moment from "moment";
import React, { useEffect, useState } from "react";
import FooterPagination from "../../../../common/FooterPagination";
import {
  GROWTH_CHART_PAGE_SIZE,
  PATIENT_VISITS_HEADER,
} from "../../../ERXConstants/constants";
import "./patientsVisits.scss";

const PatientsVisits = (props) => {
  const { patientVisits, handleSelectVisit } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [patientVisitsList, setPatientVisitsList] = useState([]);

  // <==== LifeCycle
  useEffect(() => {
    if (patientVisits?.length > 0) {
      getVisitsList(patientVisits);
    } else {
      setPatientVisitsList([]);
    }
  }, [patientVisits, currentPage]);

  //   ====>

  // <=== Actions

  const onPageChange = (pageNo) => {
    setCurrentPage(pageNo);
  };

  // ====>

  //  <====Helper

  const getVisitsList = (details) => {
    let visitListForCurrentPage = details?.filter(
      (visits) => visits.pageNo === Number(currentPage)
    );
    setPatientVisitsList(visitListForCurrentPage);
  };

  // ====>

  const renderTableHeader = () => {
    return (
      <div className="row pv_table_header">
        {PATIENT_VISITS_HEADER.map((data, i) => (
          <div className={`${data?.className}`} key={i}>
            {data.name}
          </div>
        ))}
      </div>
    );
  };

  const renderTableContent = () => {
    return (
      <div>
        {patientVisitsList?.map((data, index) => (
          <div
            className={`row pv_table_content ${
              data?.selected ? "pv_selected_record" : "pv_default_record"
            }`}
            key={index}
            onClick={() => {
              handleSelectVisit(data);
            }}
          >
            <div className="col-2">
              {moment(data.appointment_date).format("MMM DD, YYYY")}
            </div>
            <div className="col-2">{data?.weight ? data?.weight : "-"}</div>
            <div className="col-3">{data?.height ? data?.height : "-"}</div>
            <div className="col-2 to_capitalize">
              {data?.measured ? data?.measured : "-"}
            </div>
            <div className="col-1">{data?.bmi ? data?.bmi : "-"}</div>
            <div className="col-1">
              {data?.head_circumference ? data?.head_circumference : "-"}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderTableNoContent = () => {
    return <div className="pv_no_record">No Records</div>;
  };

  const renderTableBody = () => {
    return (
      <>
        {patientVisitsList?.length > 0
          ? renderTableContent()
          : renderTableNoContent()}
      </>
    );
  };

  const renderDestopView = () => {
    return (
      <>
        {renderTableHeader()}
        {renderTableBody()}
      </>
    );
  };

  const renderMobileView = () => {
    return (
      <div>
        {patientVisitsList?.map((data, index) => (
          <div
            className={`row pv_mv_container ${
              data?.selected ? "pv_mv_selected_record" : ""
            }`}
            key={index}
            onClick={() => {
              handleSelectVisit(data);
            }}
          >
            <div className="col-12 pv_mv_date">
              {" "}
              {moment(data.appointment_date).format("MMM DD, YYYY")}
            </div>
            <div className="col-4 pr-2">
              <div className="pv_mv_title">Weight (KG)</div>
              <div className="pv_mv_content">
                {data?.weight ? data?.weight : "-"}
              </div>
            </div>
            <div className="col-5 pr-2">
              <div className="pv_mv_title">Length/Height (cm)</div>
              <div className="pv_mv_content">
                {data?.height ? data?.height : "-"}
              </div>
            </div>
            <div className="col-3 pr-2">
              <div className="pv_mv_title">BMI</div>
              <div className="pv_mv_content">
                {" "}
                {data?.bmi ? data?.bmi : "-"}
              </div>
            </div>
            <div className="col-4 pr-2">
              <div className="pv_mv_title">HC (Cm)</div>
              <div className="pv_mv_content">
                {data?.head_circumference ? data?.head_circumference : "-"}
              </div>
            </div>
            <div className="col-5 pr-2">
              <div className="pv_mv_title">Measured</div>
              <div className="pv_mv_content to_capitalize">
                {data?.measured ? data?.measured : "-"}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderPagination = () => {
    return (
      <div className="patient-visits-pagination">
        <FooterPagination
          currentPage={currentPage}
          totalCount={patientVisits?.length}
          pageSize={GROWTH_CHART_PAGE_SIZE}
          onPageChange={onPageChange}
        />
      </div>
    );
  };

  const PatientsVisitsView = () => {
    return (
      <>
        {window.innerWidth > 767 ? renderDestopView() : renderMobileView()}
        {patientVisitsList?.length > 0 && renderPagination()}
      </>
    );
  };

  return <div className="mb-3">{PatientsVisitsView()}</div>;
};

export default PatientsVisits;
